// src/constants.js
import Javascript from "./Assets/javascript-logo-svgrepo-com.svg"
import HTML from "./Assets/htmlhint-svgrepo-com.svg"
import React_Native from "./Assets/react-svgrepo-com.svg"
import Xcode from "./Assets/xcode-svgrepo-com.svg"
import GraphQl from "./Assets/file-gql-svgrepo-com.svg"
import Redux from "./Assets/redux-svgrepo-com.svg"
import Tailwind_css from  "./Assets/tailwindcss-icon-svgrepo-com.svg"
import Visual from "./Assets/visualstudio-svgrepo-com.svg"
import RestApi from "./Assets/rest-api-svgrepo-com.svg"
import Firebase from "./Assets/firebase-svgrepo-com.svg"
import Typescript from "./Assets/typescript-svgrepo-com.svg"
import Postman from "./Assets/postman-icon-svgrepo-com.svg"
import Gmail from "./Assets/gmail-icon-logo-svgrepo-com.svg"
import Call from "./Assets/call-receive-svgrepo-com.svg"
import Whatsapp from "./Assets/whatsapp-symbol-logo-svgrepo-com.svg"
import Git from "./Assets/github-142-svgrepo-com.svg"
import LinkedIn from "./Assets/linkedin-1-svgrepo-com.svg"
import Resume from "./Assets/View.svg"
import CSS from "./Assets/css-3-svgrepo-com.svg"
// Personal Information
export const PERSONAL_INFO = {
    name: "Vilas K Lamani",
    title: "React Developer | JavaScript Enthusiast",
    email: "vijasriias@gmail.com",
    location: "Bengaluru, India",
    github: "https://github.com/Vilas22",
    linkedin: "https://www.linkedin.com/in/vilas-lamani",
    education: {
        degree: "BE in Electronics And Communication Engineering",
        institution: "The National Institute of Engineering, Mysore",
        graduationYear: 2021
      }
  };
  
  // Skills
  export const SKILLS = [
    {
        name: "React.js",
        image: React_Native
    },
    {
        name: "React Native",
        image: React_Native
    },
    {
        name: "JavaScript",
        image: Javascript
    },
    {
        name: "HTML",
        image: HTML
    },
    {
        name: "CSS",
        image: CSS
    },
    {
        name: "Tailwind CSS",
        image: Tailwind_css
    },
    {
        name: "TypeScript",
        image: Typescript
    },
    {
        name: "Redux",
        image: Redux
    },
    {
        name: "GraphQL",
        image: GraphQl // Add an icon if you have one
    },
    {
        name: "REST APIs",
        image: RestApi
    },
    {
        name: "Firebase",
        image: Firebase
    },
    {
        name: "Postman",
        image: Postman
    },
    {
        name: "Xcode",
        image: Xcode
    },
   
    {
        name: "Visual Studio",
        image: Visual // Assuming this is an appropriate icon
    },

];
  
  // Project List
  export const PROJECTS = [
    {
        title: "SpringBig Mobile App",
        description: "Enhancing customer engagement and loyalty for cannabis retailers. Features include loyalty programs, mobile ordering, and push notifications.",
        tech: "React Native, Redux, Firebase",
        link: "https://play.google.com/store/apps/developer?id=Springbig&hl=en_IN"
    },
    
    {
      title: "Mahindra Finance Super App",
      description: "Empowering people across India by providing financial opportunities. Features include EMI Calculator and multi-language support.",
      tech: "React.js, Tailwind CSS, JavaScript",
      link: "https://www.mahindrafinance.com/"
    },
    {
      title: "Freelanced Restaurant Web Application",
      description: "A fully functional web app for restaurant management, built with React.js and deployed on Netlify.",
      tech: "React.js, Tailwind CSS, HTML",
      link: "https://bbckitchen.netlify.app/"
    },
    {
      title: "Freelanced Shri Financial Solution pvt ltd web application",
      description: "A fully functional and small scale  web app for financial solutions, built with React.js and deployed on Netlify.",
      tech: "React.js, Tailwind CSS, HTML",
      link: "https://shri-financial-solutions.netlify.app/"
    },
    {
      title: "Local Professionals Booking App",
      description: "An app for booking local professionals, built with React Native and integrating geolocation services.",
      tech: "React Native, GraphQL, Clerk",
      link: "#"
    }
  ];
  const whatsappMessage = encodeURIComponent("Hi, I would like to get in touch with you!");

  
  // Contact Information
  export const CONTACTS =[
    
    {
     type:"vijasriias@gmail.com",
     Link:null,
     icon:Gmail
    },
    {
        type:"github",
        Link:"https://github.com/Vilas22",
        icon:Git
       },
       {
        type:"LinkedIn",
        Link:"https://www.linkedin.com/in/vilas-lamani",
        icon:LinkedIn
       },
       {
        type:"+91-7090393812",
        Link:null,
        icon:Call
       },
       {
        type:"WhatsApp",
        Link:`https://wa.me/7090393812?text=${whatsappMessage}`,
        icon:Whatsapp,

       },
       {
        type:"Resume",
        Link:"https://drive.google.com/file/d/1oKec0V97yR2oQvPkcXfTUUcaFb4ddzoB/view?usp=sharing",
        icon:Resume
       },

  ]
  
  export const CERTIFICATIONS = [
    {
      title: "JavaScript Algorithms and Data Structures",
      issuer: "freeCodeCamp",
      link: "https://www.freecodecamp.org/certification/Vilas_Lamani/javascript-algorithms-and-data-structures",
    },
    {
      title: "Responsive Web Design",
      issuer: "freeCodeCamp",
      link: "https://www.freecodecamp.org/certification/Vilas_Lamani/responsive-web-design",
    },
    {
      title: "HackerRank Problem Solving",
      issuer: "HackerRank",
      link: "https://www.hackerrank.com/certificates/iframe/a547d00ee1f5",
    },
  ];